import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQ_ITEMS } from "../data/content";
import { Reveal } from "./Reveal";

export const Faq = () => (
  <section className="bg-slate-50 py-16 sm:py-24 lg:py-32" data-testid="faq-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 sm:px-6 lg:grid-cols-5 lg:gap-20 lg:px-12">
      <Reveal className="lg:col-span-2">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-sky-600">DUK</p>
        <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-navy-900 sm:text-3xl lg:text-4xl">
          Dažniausiai užduodami klausimai
        </h2>
        <p className="mt-5 text-base leading-relaxed text-slate-600">
          Nerandate atsakymo? Parašykite mums per kontaktų puslapį arba užsiregistruokite nemokamam matavimui — viską papasakosime vietoje.
        </p>
      </Reveal>

      <Reveal delay={0.15} className="lg:col-span-3">
        <Accordion type="single" collapsible className="space-y-3">
          {FAQ_ITEMS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-2xl border border-slate-200 bg-white px-6 transition-colors duration-300 data-[state=open]:border-sky-300 data-[state=open]:shadow-[0_16px_40px_-20px_rgba(2,132,199,0.25)]"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-5 text-left font-heading text-base font-semibold text-navy-900 hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-600">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
